import React, { Component } from 'react'
import { Card, CardBody, Row, Col, Label, Button, CardHeader } from "reactstrap";
import { urlGuardarCoberturasPymes } from '../../../constants/urls'
import CompletarCoberturas from '../../CotizacionPymes/CotizacionPymes4/CompletarCoberturas'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { nombreGiroNegocio } from '../../../redux/selectors/sPymes'
import { apiPost } from '../../../api'
import { totales } from '../../../constants'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import RoboAsaltos from '../../CotizacionPymes/CotizacionPymes4/RoboAsalto'
import EquipoElectronico from '../../CotizacionPymes/CotizacionPymes4/EquipoElectronico'
import RoturaMaquinarias from '../../CotizacionPymes/CotizacionPymes4/RoturaMaquinarias'
import DineroValores from '../../CotizacionPymes/CotizacionPymes4/DineroValores'
import AccidentesPersonales from '../../CotizacionPymes/CotizacionPymes4/AccidentesPersonales'
import Fidelidad from '../../CotizacionPymes/CotizacionPymes4/Fidelidad'
import Terrorismo from '../../CotizacionPymes/CotizacionPymes4/Terrorismo'
import ResponsabilidadCivil from '../../CotizacionPymes/CotizacionPymes4/ResponsabilidadCivil'
import ContainerCoberturaPymes from '../../../containers/CotizacionPymes/ContainerCoberturaPymes';
import TransporteInterno from '../../CotizacionPymes/CotizacionPymes4/TransporteInterno';
import LucroCesante from '../../CotizacionPymes/CotizacionPymes4/LucroCesante';

class CotizacionPymes4Diners extends Component {
    constructor(props) {
        super(props)
        this.state = { ubSelecCober: 0, totales, loading: false, proximaCobertura: true }

        
    }


    componentDidMount(){
        console.log(this.props)
    }
    toggleLoading = (loading) => {
        this.setState({ loading })
    }
    handleGuardarCoberturas = async ({ generales, arrayData, idCobertura }) => {
        this.toggleLoading(true)

        const { idCarrito, cliCodigoCore } = this.props
        let url = urlGuardarCoberturasPymes.replace('{idCarrito}', idCarrito)
        url = url.replace('{idCobertura}', idCobertura)
        url = url.replace('{cliCodigoCore}', cliCodigoCore)

        let datos = []
        arrayData.forEach(element => {
            let valor = {}
            element.forEach(({ codigo, value }) => {
                valor = { ...valor, [codigo]: value }
            });
            datos.push(valor)
        });

        console.log('AAAAAAAA', datos, generales)

        let res = await apiPost(url, { datos, generales })
        if (res.transaccion) {
            const { totales } = res
            this.setState({ totales, proximaCobertura: false, ...res })
        }
        this.toggleLoading(false)
        return res
    }
    handleNextCobertura = async () => {
        let { ubSelecCober } = this.state
        const { arrayCoberturas } = this.props
        console.log('TTTTTT', ubSelecCober + 1 < arrayCoberturas.length, ubSelecCober, arrayCoberturas.length, !!this.props.arrayCoberturas[ubSelecCober], this.props.arrayCoberturas[ubSelecCober])
        if (ubSelecCober + 1 < arrayCoberturas.length) {
            ubSelecCober++;
            if (this.props.arrayCoberturas[ubSelecCober])
                await this.props.fetchMaximos(this.props.arrayCoberturas[ubSelecCober].codigo)
            this.setState({ ubSelecCober })
        } else {
            this.props.handleResumen()
        }
    }
    handleBackCobertura = () => {
        let { ubSelecCober } = this.state
        if (ubSelecCober === 0)
            this.props.handleBack()
        else {
            ubSelecCober--;
            this.setState({ ubSelecCober })
        }
    }

    handleRedirecionarResumenRecarga = () => {
        this.props.history.replace({
            pathname: '/pymesDiners/cotizador',
            search: `paso=resumen&id=${this.props.idCarrito}`,
        })
    }

    render() {

        let { arrayCoberturas, nombreGiro, arrayUbicaciones, generalesValues } = this.props
        const { ubSelecCober, loading, totales, proximaCobertura } = this.state
        if (arrayCoberturas.length === 0) {
            this.handleRedirecionarResumenRecarga()
        }

        console.log('PYMES4', this.props)
        return (
            <LoadingScreen
                loading={loading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando..."
            >
                <Row >

                    <Col xl={11} md={12} className="div-align-center">
                        <div className='row'>
                            {arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'incendioAliadas' ?
                                <CompletarCoberturas
                                    arrayUbicaciones={arrayUbicaciones}
                                    titulo={arrayCoberturas[ubSelecCober].nombre}
                                    nombreGiro={nombreGiro}
                                    esCoberturaGeneral={true}
                                    esCoberturaPorUbicaciones={true}
                                    idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                    guardarCobertura={this.handleGuardarCoberturas}
                                    handleAtras={this.handleBackCobertura}
                                    handleNext={this.handleNextCobertura}
                                    volverResumen={this.props.volverResumen}
                                />
                                : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'roboAsalto' ?
                                    <RoboAsaltos
                                        arrayUbicaciones={arrayUbicaciones}
                                        titulo={arrayCoberturas[ubSelecCober].nombre}
                                        nombreGiro={nombreGiro}
                                        idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                        guardarCobertura={this.handleGuardarCoberturas}
                                        handleAtras={this.handleBackCobertura}
                                        handleNext={this.handleNextCobertura}
                                    /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'equipoElectronico' ?
                                        <EquipoElectronico
                                            arrayUbicaciones={arrayUbicaciones}
                                            titulo={arrayCoberturas[ubSelecCober].nombre}
                                            nombreGiro={nombreGiro}
                                            idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                            guardarCobertura={this.handleGuardarCoberturas}
                                            handleAtras={this.handleBackCobertura}
                                            handleNext={this.handleNextCobertura}
                                        /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'roturaMaquinaria' ?
                                            <RoturaMaquinarias
                                                arrayUbicaciones={arrayUbicaciones}
                                                titulo={arrayCoberturas[ubSelecCober].nombre}
                                                nombreGiro={nombreGiro}
                                                idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                guardarCobertura={this.handleGuardarCoberturas}
                                                handleAtras={this.handleBackCobertura}
                                                handleNext={this.handleNextCobertura}
                                            /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'dineroValores' ?
                                                <DineroValores
                                                    arrayUbicaciones={arrayUbicaciones}
                                                    titulo={arrayCoberturas[ubSelecCober].nombre}
                                                    nombreGiro={nombreGiro}
                                                    idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                    guardarCobertura={this.handleGuardarCoberturas}
                                                    handleAtras={this.handleBackCobertura}
                                                    handleNext={this.handleNextCobertura}
                                                /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'accidentesPersonales' ?
                                                    <AccidentesPersonales
                                                        arrayUbicaciones={arrayUbicaciones}
                                                        titulo={arrayCoberturas[ubSelecCober].nombre}
                                                        nombreGiro={nombreGiro}
                                                        idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                        guardarCobertura={this.handleGuardarCoberturas}
                                                        handleAtras={this.handleBackCobertura}
                                                        handleNext={this.handleNextCobertura}
                                                    /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'fidelidad' ?
                                                        <Fidelidad
                                                            arrayUbicaciones={arrayUbicaciones}
                                                            titulo={arrayCoberturas[ubSelecCober].nombre}
                                                            nombreGiro={nombreGiro}
                                                            idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                            guardarCobertura={this.handleGuardarCoberturas}
                                                            handleAtras={this.handleBackCobertura}
                                                            handleNext={this.handleNextCobertura}
                                                        /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'terrorismo' ?
                                                            <ContainerCoberturaPymes
                                                                arrayUbicaciones={arrayUbicaciones}
                                                                titulo={arrayCoberturas[ubSelecCober].nombre}
                                                                esCoberturaGeneral={true}
                                                                esCoberturaPorUbicaciones={false}
                                                                nombreGiro={nombreGiro}
                                                                idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                                guardarCobertura={this.handleGuardarCoberturas}
                                                                handleAtras={this.handleBackCobertura}
                                                                handleNext={this.handleNextCobertura}
                                                            /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'transporteInterno' ?
                                                                <TransporteInterno
                                                                    arrayUbicaciones={arrayUbicaciones}
                                                                    titulo={arrayCoberturas[ubSelecCober].nombre}
                                                                    esCoberturaGeneral={true}
                                                                    esCoberturaPorUbicaciones={false}
                                                                    nombreGiro={nombreGiro}
                                                                    idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                                    guardarCobertura={this.handleGuardarCoberturas}
                                                                    handleAtras={this.handleBackCobertura}
                                                                    handleNext={this.handleNextCobertura}
                                                                /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'respCivil' ?
                                                                    <ResponsabilidadCivil
                                                                        arrayUbicaciones={arrayUbicaciones}
                                                                        titulo={arrayCoberturas[ubSelecCober].nombre}
                                                                        generalesValues={generalesValues}
                                                                        nombreGiro={nombreGiro}
                                                                        idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                                        guardarCobertura={this.handleGuardarCoberturas}
                                                                        handleAtras={this.handleBackCobertura}
                                                                        handleNext={this.handleNextCobertura}
                                                                    /> : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'lucroCesante' ?
                                                                        <LucroCesante
                                                                            arrayUbicaciones={arrayUbicaciones}
                                                                            titulo={arrayCoberturas[ubSelecCober].nombre}
                                                                            nombreGiro={nombreGiro}
                                                                            idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                                            guardarCobertura={this.handleGuardarCoberturas}
                                                                            handleAtras={this.handleBackCobertura}
                                                                            handleNext={this.handleNextCobertura}
                                                                        />
                                                                        : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'lucroCesanteRotura' ?
                                                                            <ContainerCoberturaPymes
                                                                                arrayUbicaciones={arrayUbicaciones}
                                                                                titulo={arrayCoberturas[ubSelecCober].nombre}
                                                                                esCoberturaGeneral={true}
                                                                                esCoberturaPorUbicaciones={false}
                                                                                nombreGiro={nombreGiro}
                                                                                idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                                                guardarCobertura={this.handleGuardarCoberturas}
                                                                                handleAtras={this.handleBackCobertura}
                                                                                handleNext={this.handleNextCobertura}
                                                                            />
                                                                            : arrayCoberturas.length > 0 && arrayCoberturas[ubSelecCober].codigo === 'equipoMaquinaria' ?
                                                                                <ContainerCoberturaPymes
                                                                                    arrayUbicaciones={arrayUbicaciones}
                                                                                    titulo={arrayCoberturas[ubSelecCober].nombre}
                                                                                    esCoberturaGeneral={true}
                                                                                    esCoberturaPorUbicaciones={true}
                                                                                    nombreGiro={nombreGiro}
                                                                                    idCobertura={arrayCoberturas[ubSelecCober].codigo}
                                                                                    guardarCobertura={this.handleGuardarCoberturas}
                                                                                    handleAtras={this.handleBackCobertura}
                                                                                    handleNext={this.handleNextCobertura}
                                                                                />
                                                                                : <div> Ocurrio un error al cargar la página. Recargue la página </div>
                            }
                            <Col md={4}>
                                <div className="card card-body" >
                                    <div className="flex itemDescripcion" style={{ borderBottom: 'solid 1px #ecedf0', }} > <label style={{ fontWeight: 700, }} > Valor del Seguro </label>  </div>
                                    <div className="flex itemDescripcion" > <label> Prima neta </label> ${totales.primaNeta} </div>
                                    <div className="flex itemDescripcion" > <label> Super intendencia </label> $ {totales.superintendencia} </div>
                                    <div className="flex itemDescripcion" > <label> Impuesto campesino </label> $ {totales.impCampesino} </div>
                                    <div className="flex itemDescripcion" > <label> Derechos de Emisión </label> $ {totales.derechoEmision} </div>
                                    <div className="flex itemDescripcion" > <label> Base imponible </label> $ {totales.baseImponible} </div>
                                    <div className="flex itemDescripcion" > <label> IVA % </label> $ {totales.iva} </div>
                                    <div className="flex itemDescripcion" style={{ borderBottom: 'solid 1px #ecedf0', }} > <label style={{ fontWeight: 700, }}> Prima total </label> ${totales.primaTotal} </div>
                                    <div style={{ marginTop: 10, }}>
                                        <Button disabled={proximaCobertura} className="btn btn-primary" onClick={() => this.handleNextCobertura()} style={{ display: "block", margin: "auto", }} >
                                            <i className="fa fa-chevron-circle-right" aria-hidden="true" />{"  CONTINUAR"}
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </div >
                    </Col>
                </Row>
            </LoadingScreen>

        )
    }
}
const mapStateToProps = (state, props) => ({

    nombreGiro: nombreGiroNegocio(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore
});
const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null
    )(CotizacionPymes4Diners)
);
